import type { Agency } from "@features/user"
import type React from "react"
import useEnv from "../../../hooks/useEnv"
import styles from "./FooterGea.module.css"

interface FooterGeaProps {
  agency: Agency
  agencyLabel?: string
}

const FooterGea: React.FC<FooterGeaProps> = ({
  agency,
  agencyLabel = "RNAVT",
}) => {
  const { geconturUrl } = useEnv()

  const logoImagePath = agency?.logo_path
    ? `${geconturUrl}/img/agencies/${agency?.logo_path}`
    : "https://placehold.co/150x150/jpg?text=Logo"
  return (
    <div className="flex">
      <div className="w-1/2 pl-2">
        <img
          className={styles.Image}
          alt="logo"
          height="62"
          src={logoImagePath}
        />
      </div>

      <div className="ml-auto">
        <div className={styles.Address}>
          {agency?.social_denomination}
          <br />
          {agency?.address}
          <br />
          {agency?.postal_code} {agency?.locale}
          <br />
          <br />
          {agencyLabel} {agency?.RNAVT}
        </div>
      </div>
    </div>
  )
}

export default FooterGea
